import { el } from 'redom';

import { formatDateObjectToApplicationTime } from 'utilities/date';
import monthNumberAndShortNameMap from './month-number-and-short-name-map';

class EventDateTimeDisplay {

  constructor(dateTime, formattedDate, formattedTime) {

    this.dateTime = dateTime;
    this.formattedDate = formattedDate;
    this.formattedTime = formattedTime;

    this.dateViewEl = el('h2.event-day-text');
    this.monthViewEl = el('h4.event-month-text');
    this.dateMonthViewContainerEl = el('div.event-date-month-view-container', [this.dateViewEl, this.monthViewEl]);
    this.timeViewEl = el('span.event-time-text');
    this.verticalDividerViewEl = el('div.vertical-divider');
    this.el = el('div.event-date-time-view-container', [this.dateMonthViewContainerEl, this.verticalDividerViewEl, this.timeViewEl]);

    this.updateDayMonthAndTime();

  }

  getDayMonthAndTime() {

    const [, monthNumber, day] = this.formattedDate.split('-');
    const month = monthNumberAndShortNameMap[monthNumber];
    const time = formatDateObjectToApplicationTime(new Date(this.dateTime));

    return [day, month, time];

  }

  updateDayMonthAndTime() {

    const [day, month, time] = this.getDayMonthAndTime();

    this.dateViewEl.textContent = day;
    this.monthViewEl.textContent = month;
    this.timeViewEl.textContent = time;

  }

  update(dateTime, formattedDate, formattedTime) {

    this.dateTime = dateTime;
    this.formattedDate = formattedDate;
    this.formattedTime = formattedTime;

    this.updateDayMonthAndTime();

  }

};

export default EventDateTimeDisplay;